import * as React from 'react';
import i18n from '@/utils/i18n';
import Spinner from '../../components/LoadingSpinner';
import moment from 'moment';
import { useGetTransactionQuery } from '../../graphql/queries/getTransaction.generated';

type TransactionHistoryTableProps = {
  pickpackTransactionId: string | null;
};

export const TransactionHistoryTable = function TransactionHistoryTable({
  pickpackTransactionId,
}: TransactionHistoryTableProps) {
  const { data, loading } = useGetTransactionQuery({
    skip: pickpackTransactionId == null,
    variables: { transaction_id: pickpackTransactionId || '' },
  });
  const transaction = data?.getTransaction;

  return (
    <div>
      {loading && <Spinner />}
      {!loading && transaction && (transaction.history || []).length == 0 && (
        <b> {i18n.t('Billing:transactionNotFound')} </b>
      )}

      <h4>{i18n.t('Billing:transaction')}</h4>
      {transaction && (
        <table className="table-striped table">
          <tbody>
            <tr>
              <td>{i18n.t('Billing:status')}</td>
              <td>{transaction.state}</td>
            </tr>
            <tr>
              <td>{i18n.t('Billing:chargeId')}</td>
              <td>{transaction.charge_id}</td>
            </tr>
            <tr>
              <td>{i18n.t('Billing:userId')}</td>
              <td>{transaction.user_id}</td>
            </tr>
            <tr>
              <td>{i18n.t('Billing:creditsUsed')}</td>
              <td>{(transaction.credits_used ?? 0) / 100}</td>
            </tr>
            <tr>
              <td>{i18n.t('Billing:tapToBorrowStripeAccountCountry')}</td>
              <td>{transaction.tap_to_borrow_stripe_account_country ?? ''}</td>
            </tr>
          </tbody>
        </table>
      )}
      <h4>{i18n.t('Billing:transactionHistory')}</h4>
      {transaction && (
        <table
          className="table-striped table"
          style={{ background: 'white', borderRadius: 4 }}
        >
          <thead>
            <tr>
              <th>{i18n.t('Common:state')}</th>
              <th>{i18n.t('Common:updatedAt')}</th>
            </tr>
          </thead>
          <tbody>
            {(transaction.history || []).map((entry) => {
              if (entry != null) {
                return (
                  <tr
                    key={'t' + entry.updated_at}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{entry.state}</td>
                    <td>
                      {moment(entry.updated_at).format('HH:mm:ss - DD.MM.YYYY')}
                    </td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};
